import { useNavigate } from "react-router-dom";
import { RiMapPin2Line } from "react-icons/ri";
import { FiChevronRight } from "react-icons/fi";
import { BsChatDots } from "react-icons/bs";
import { IoLogOutOutline } from "react-icons/io5";
import BottomBarMobile from "../../components/common/BottomBarMobile";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/features/auth/authSlice";
import { useContext, useEffect, useState } from "react";
import { GlobalStateContext } from "../../components/context/GlobalStateContext";
import SwipeConfirm from "../../components/swipeComp/SwipeConfirm";
import { AiOutlineLogin } from "react-icons/ai";
import { LuUserPlus } from "react-icons/lu";
import { TbArrowsMaximize, TbArrowsMinimize } from "react-icons/tb";
import { useQuery } from "@tanstack/react-query";
import { getDetailUserProfile } from "../../services/profileApi";
import { FaUserCircle } from "react-icons/fa";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLogin, setIsLogin } = useContext(GlobalStateContext);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showFullscreenButton, setShowFullscreenButton] = useState(true);

  const { data, isFetching } = useQuery({
    queryKey: ["detail-user-profile"],
    queryFn: () => getDetailUserProfile(),
    enabled: isLogin === true,
    keepPreviousData: false,
  });

  const handleLogout = () => {
    dispatch(logout());
    setIsLogin(false);
    navigate("/purchase");
  };

  useEffect(() => {
    const checkIOS = () => {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };

    const iosDevice = checkIOS();

    setShowFullscreenButton(!iosDevice);
  }, []);

  useEffect(() => {
    if (!showFullscreenButton) return;

    const handleFullscreenChange = () => {
      setIsFullscreen(
        !!document.fullscreenElement ||
          !!document.webkitFullscreenElement ||
          !!document.mozFullScreenElement ||
          !!document.msFullscreenElement,
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange,
      );
    };
  }, [showFullscreenButton]);

  const toggleFullScreen = () => {
    if (!showFullscreenButton) return;

    const doc = document.documentElement;

    if (
      !document.fullscreenElement &&
      !document.webkitFullscreenElement &&
      !document.mozFullScreenElement &&
      !document.msFullscreenElement
    ) {
      if (doc.requestFullscreen) {
        doc.requestFullscreen();
      } else if (doc.webkitRequestFullscreen) {
        doc.webkitRequestFullscreen();
      } else if (doc.mozRequestFullScreen) {
        doc.mozRequestFullScreen();
      } else if (doc.msRequestFullscreen) {
        doc.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  const desktopMenuLoggedIn = [
    {
      icon: <RiMapPin2Line size={22} />,
      label: "Alamat Saya",
      desc: "Kelola alamat pengiriman",
      action: () => navigate("/location-address/my-address"),
      iconColor: "#2563eb",
      iconBg: "#eff6ff",
    },
    {
      icon: <BsChatDots size={22} />,
      label: "Riwayat Konsultasi",
      desc: "Lihat riwayat chat dengan dokter",
      action: () => navigate("/consultation/history"),
      iconColor: "#059669",
      iconBg: "#f0fdf4",
    },
    ...(showFullscreenButton
      ? [
          {
            icon: isFullscreen ? (
              <TbArrowsMinimize size={22} />
            ) : (
              <TbArrowsMaximize size={22} />
            ),
            label: isFullscreen ? "Keluar layar penuh" : "Layar penuh",
            desc: "Atur tampilan layar browser",
            action: toggleFullScreen,
            iconColor: "#7c3aed",
            iconBg: "#f5f3ff",
          },
        ]
      : []),
    {
      icon: <IoLogOutOutline size={22} />,
      label: "Keluar",
      desc: "Logout dari akun Anda",
      action: () => setOpenConfirm(true),
      iconColor: "#dc2626",
      iconBg: "#fef2f2",
      danger: true,
    },
  ];

  const desktopMenuGuest = [
    {
      icon: <AiOutlineLogin size={22} />,
      label: "Masuk",
      desc: "Login ke akun yang sudah ada",
      action: () => navigate("/login"),
      iconColor: "#2563eb",
      iconBg: "#eff6ff",
    },
    {
      icon: <LuUserPlus size={22} />,
      label: "Daftar",
      desc: "Buat akun baru secara gratis",
      action: () => navigate("/register"),
      iconColor: "#059669",
      iconBg: "#f0fdf4",
    },
    ...(showFullscreenButton
      ? [
          {
            icon: isFullscreen ? (
              <TbArrowsMinimize size={22} />
            ) : (
              <TbArrowsMaximize size={22} />
            ),
            label: isFullscreen ? "Keluar layar penuh" : "Layar penuh",
            desc: "Atur tampilan layar browser",
            action: toggleFullScreen,
            iconColor: "#7c3aed",
            iconBg: "#f5f3ff",
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="bg-white relative lg:hidden">
        <div className="flex flex-row justify-center h-screen">
          <div className="w-full lg:w-1/2 flex justify-center lg:items-center px-0 lg:px-12 text-base">
            <div className="rounded-md p-4 lg:p-8 w-full h-fit">
              {!isLogin ? (
                <div className="w-full">
                  <div className="flex flex-col gap-2">
                    <div
                      onClick={() => navigate("/login")}
                      className="py-1 flex items-center justify-between text-gray-500"
                    >
                      <div className="flex items-center gap-2">
                        <AiOutlineLogin size={20} />
                        <p className="text-slate-700">Masuk</p>
                      </div>
                      <FiChevronRight size={20} />
                    </div>
                    <div
                      onClick={() => navigate("/register")}
                      className="py-1 flex items-center justify-between text-gray-500"
                    >
                      <div className="flex items-center gap-2">
                        <LuUserPlus size={20} />
                        <p className="text-slate-700">Daftar</p>
                      </div>
                      <FiChevronRight size={20} />
                    </div>
                    <div
                      onClick={toggleFullScreen}
                      className="py-1 flex items-center justify-between text-gray-500"
                    >
                      <div className="flex items-center gap-2">
                        {isFullscreen ? (
                          <TbArrowsMinimize size={20} />
                        ) : (
                          <TbArrowsMaximize size={20} />
                        )}
                        <p className="text-slate-700">
                          {isFullscreen
                            ? "Keluar dari layar penuh"
                            : "Masuk ke layar penuh"}
                        </p>
                      </div>
                      <FiChevronRight size={20} />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-full">
                  <div className="mb-6">
                    <div className="w-full rounded-xl border-2 border-gray-200 bg-gray-50 flex flex-col items-center justify-center p-3 mb-2">
                      {data && data.profile_image === "" && !isFetching ? (
                        <FaUserCircle className="w-[150px] h-[150px] rounded-full text-gray-300 border-2 border-gray-200" />
                      ) : isFetching ? (
                        <div className="w-[150px] h-[150px] rounded-full bg-slate-200 border-2 border-gray-200"></div>
                      ) : (
                        <img
                          src={data && data.profile_image}
                          alt="Profile IMG"
                          className="w-[150px] h-[150px] rounded-full object-cover border-2 border-gray-200"
                        />
                      )}
                      {data && !isFetching ? (
                        <h1 className="font-medium mt-2">
                          {data && data.fullname}
                        </h1>
                      ) : (
                        <div className="h-5 rounded-md w-3/4 bg-slate-200 mt-2 mb-1"></div>
                      )}
                      {data && data.email && !isFetching ? (
                        <p className="text-md mb-2">{data && data.email}</p>
                      ) : (
                        <div className="h-4 rounded-md w-2/4 bg-slate-200 mb-2"></div>
                      )}
                      <button
                        disabled={isFetching}
                        onClick={() => navigate("/profile/change")}
                        className="h-[40px] text-base border border-secondary flex items-center justify-center bg-secondary text-white w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryHover transform duration-200 hover:scale-100 disabled:bg-slate-300 disabled:border-slate-300 disabled:cursor-disabled"
                      >
                        <p>Ubah</p>
                      </button>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2">
                    <div
                      onClick={() => navigate("/location-address/my-address")}
                      className="py-1 flex items-center justify-between text-gray-500"
                    >
                      <div className="flex items-center gap-2">
                        <RiMapPin2Line size={20} />
                        <p className="text-slate-700">Alamat Saya</p>
                      </div>
                      <FiChevronRight size={20} />
                    </div>
                    <div
                      onClick={() => navigate("/consultation/history")}
                      className="py-1 flex items-center justify-between text-gray-500"
                    >
                      <div className="flex items-center gap-2">
                        <BsChatDots size={20} />
                        <p className="text-slate-700">Riwayat Konsultasi</p>
                      </div>
                      <FiChevronRight size={20} />
                    </div>
                    {showFullscreenButton && (
                      <div
                        onClick={toggleFullScreen}
                        className="py-1 flex items-center justify-between text-gray-500"
                      >
                        <div className="flex items-center gap-2">
                          {isFullscreen ? (
                            <TbArrowsMinimize size={20} />
                          ) : (
                            <TbArrowsMaximize size={20} />
                          )}
                          <p className="text-slate-700">
                            {isFullscreen
                              ? "Keluar dari layar penuh"
                              : "Masuk ke layar penuh"}
                          </p>
                        </div>
                        <FiChevronRight size={20} />
                      </div>
                    )}
                    <div
                      onClick={() => setOpenConfirm(true)}
                      className="py-1 flex items-center justify-between text-gray-500"
                    >
                      <div className="flex items-center gap-2">
                        <IoLogOutOutline size={20} />
                        <p className="text-slate-700">Keluar</p>
                      </div>
                      <FiChevronRight size={20} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="hidden lg:flex min-h-screen"
        style={{
          background:
            "linear-gradient(135deg, #f0f7ff 0%, #eaf5f1 50%, #f3f0ff 100%)",
        }}
      >
        <div
          className="hidden xl:flex w-[420px] flex-shrink-0 flex-col justify-between p-12 relative overflow-hidden"
          style={{
            background:
              "linear-gradient(160deg, #0f4c81 0%, #1565c0 45%, #0d7a62 100%)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: -70,
              right: -70,
              width: 240,
              height: 240,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.07)",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "40%",
              left: -50,
              width: 160,
              height: 160,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.04)",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: -50,
              right: 60,
              width: 180,
              height: 180,
              borderRadius: "50%",
              background: "rgba(13,122,98,0.35)",
            }}
          />

          <div style={{ position: "relative", zIndex: 1 }}>
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 16,
                background: "rgba(255,255,255,0.15)",
                border: "1px solid rgba(255,255,255,0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 26,
                marginBottom: 36,
              }}
            >
              💊
            </div>
            <h1
              style={{
                fontSize: 34,
                fontWeight: 800,
                color: "#fff",
                lineHeight: 1.2,
                margin: "0 0 16px",
              }}
            >
              Kelola akun
              <br />
              Anda dengan
              <br />
              mudah.
            </h1>
            <p
              style={{
                fontSize: 15,
                color: "rgba(255,255,255,0.6)",
                lineHeight: 1.75,
                margin: 0,
              }}
            >
              Akses semua fitur, riwayat
              <br />
              konsultasi, dan pengaturan
              <br />
              alamat dalam satu tempat.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              gap: 12,
              position: "relative",
              zIndex: 1,
            }}
          >
            {[
              { num: "24/7", label: "Konsultasi" },
              { num: "100+", label: "Dokter" },
              { num: "Cepat", label: "Pengiriman" },
            ].map((s, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  background: "rgba(255,255,255,0.1)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  borderRadius: 14,
                  padding: "14px 10px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 800,
                    color: "#fff",
                    marginBottom: 4,
                  }}
                >
                  {s.num}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "rgba(255,255,255,0.55)",
                    fontWeight: 500,
                  }}
                >
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center p-8 xl:p-16">
          <div style={{ width: "100%", maxWidth: 460 }}>
            {!isLogin ? (
              <div>
                <div style={{ marginBottom: 32 }}>
                  <div
                    style={{
                      width: 64,
                      height: 64,
                      borderRadius: 20,
                      background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 30,
                      marginBottom: 20,
                    }}
                  >
                    👤
                  </div>
                  <h2
                    style={{
                      fontSize: 28,
                      fontWeight: 800,
                      color: "#0f172a",
                      margin: "0 0 8px",
                    }}
                  >
                    Selamat datang
                  </h2>
                  <p style={{ fontSize: 15, color: "#64748b", margin: 0 }}>
                    Masuk atau daftar untuk mengakses semua fitur layanan
                  </p>
                </div>

                <div
                  style={{
                    background: "#fff",
                    borderRadius: 20,
                    boxShadow: "0 4px 32px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                  }}
                >
                  {desktopMenuGuest.map((item, i) => (
                    <button
                      key={i}
                      onClick={item.action}
                      style={{
                        width: "100%",
                        padding: "18px 22px",
                        background: "transparent",
                        border: "none",
                        borderBottom:
                          i < desktopMenuGuest.length - 1
                            ? "1px solid #f1f5f9"
                            : "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 16,
                        transition: "background 0.15s",
                        textAlign: "left",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f8fafc")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      <div
                        style={{
                          width: 44,
                          height: 44,
                          borderRadius: 13,
                          background: item.iconBg,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: item.iconColor,
                          flexShrink: 0,
                        }}
                      >
                        {item.icon}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontSize: 15,
                            fontWeight: 700,
                            color: "#0f172a",
                            marginBottom: 3,
                          }}
                        >
                          {item.label}
                        </div>
                        <div style={{ fontSize: 12, color: "#94a3b8" }}>
                          {item.desc}
                        </div>
                      </div>
                      <FiChevronRight
                        size={18}
                        style={{ color: "#cbd5e1", flexShrink: 0 }}
                      />
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <div>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 24,
                    boxShadow: "0 8px 40px rgba(0,0,0,0.09)",
                    overflow: "hidden",
                    marginBottom: 16,
                  }}
                >
                  <div
                    style={{
                      height: 96,
                      background:
                        "linear-gradient(135deg, #0f4c81 0%, #1565c0 50%, #0d7a62 100%)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: -40,
                        right: -40,
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        background: "rgba(255,255,255,0.07)",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: -30,
                        left: "40%",
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        background: "rgba(13,122,98,0.3)",
                      }}
                    />
                  </div>

                  <div style={{ padding: "0 28px 24px" }}>
                    <div
                      style={{
                        marginTop: -46,
                        marginBottom: 16,
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          width: 92,
                          height: 92,
                          borderRadius: "50%",
                          border: "4px solid #fff",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                          overflow: "hidden",
                          background: "#f1f5f9",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        {isFetching ? (
                          <div
                            className="animate-pulse"
                            style={{
                              width: "100%",
                              height: "100%",
                              background: "#e2e8f0",
                            }}
                          />
                        ) : data?.profile_image ? (
                          <img
                            src={data.profile_image}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FaUserCircle
                            style={{
                              width: "100%",
                              height: "100%",
                              color: "#cbd5e1",
                            }}
                          />
                        )}
                      </div>

                      <button
                        disabled={isFetching}
                        onClick={() => navigate("/profile/change")}
                        style={{
                          padding: "9px 20px",
                          background: isFetching
                            ? "#e2e8f0"
                            : "linear-gradient(135deg, #0f4c81, #1565c0)",
                          border: "none",
                          borderRadius: 11,
                          cursor: isFetching ? "not-allowed" : "pointer",
                          color: "#fff",
                          fontSize: 13,
                          fontWeight: 600,
                          boxShadow: isFetching
                            ? "none"
                            : "0 4px 12px rgba(21,101,192,0.35)",
                          transition: "all 0.2s",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                        onMouseEnter={(e) => {
                          if (!isFetching)
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        ✏️ Edit Profil
                      </button>
                    </div>

                    {/* Name & email */}
                    {isFetching ? (
                      <>
                        <div
                          className="animate-pulse"
                          style={{
                            height: 22,
                            background: "#e2e8f0",
                            borderRadius: 8,
                            width: "55%",
                            marginBottom: 8,
                          }}
                        />
                        <div
                          className="animate-pulse"
                          style={{
                            height: 14,
                            background: "#e2e8f0",
                            borderRadius: 8,
                            width: "40%",
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <h2
                          style={{
                            margin: "0 0 5px",
                            fontSize: 21,
                            fontWeight: 800,
                            color: "#0f172a",
                          }}
                        >
                          {data?.fullname || "—"}
                        </h2>
                        <p
                          style={{ margin: 0, fontSize: 14, color: "#64748b" }}
                        >
                          {data?.email || "—"}
                        </p>
                      </>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    background: "#fff",
                    borderRadius: 20,
                    boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
                    overflow: "hidden",
                  }}
                >
                  {desktopMenuLoggedIn.map((item, i) => (
                    <button
                      key={i}
                      onClick={item.action}
                      style={{
                        width: "100%",
                        padding: "17px 22px",
                        background: "transparent",
                        border: "none",
                        borderBottom:
                          i < desktopMenuLoggedIn.length - 1
                            ? "1px solid #f1f5f9"
                            : "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 16,
                        transition: "background 0.15s",
                        textAlign: "left",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = item.danger
                          ? "#fff5f5"
                          : "#f8fafc")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      <div
                        style={{
                          width: 44,
                          height: 44,
                          borderRadius: 13,
                          background: item.iconBg,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: item.iconColor,
                          flexShrink: 0,
                        }}
                      >
                        {item.icon}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontSize: 15,
                            fontWeight: 700,
                            color: item.danger ? "#dc2626" : "#0f172a",
                            marginBottom: 3,
                          }}
                        >
                          {item.label}
                        </div>
                        <div style={{ fontSize: 12, color: "#94a3b8" }}>
                          {item.desc}
                        </div>
                      </div>
                      <FiChevronRight
                        size={18}
                        style={{
                          color: item.danger ? "#fca5a5" : "#cbd5e1",
                          flexShrink: 0,
                        }}
                      />
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <BottomBarMobile />

      <SwipeConfirm
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        title={"Keluar?"}
        subTitle={"Keluar"}
        desc={"Anda yakin ingin keluar dari akun anda?"}
        handleConfirm={() => handleLogout()}
      />
    </>
  );
};

export default Profile;
